import React from 'react';
import {
  Button,
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { url } from '../../../constants/routes';
import './styles.css';
import Navigation from '../../../components/Navigation';
import Footer from '../../../components/Footer';
import TextHero from '../../../components/TextBanner';
import PropTypes from 'prop-types';
import { connect as reduxConnect } from '../../../reducers/index';
import AssistHoriz from './img/assist-horiz.svg';
import IdentifyHoriz from './img/identify-horiz.svg';
import ReferHoriz from './img/refer-horiz.svg';
import questions from './questions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';

class CaseStudiesQuestions extends React.Component {
  constructor(props) {
    super(props);

    const tokenizedPathname = window.location.pathname.split('/');
    const study = tokenizedPathname[tokenizedPathname.length - 1];
    if (study - 1 < 0 || study - 1 > questions.length) {
      props.history.push(url.CASESTUDIES);
    }

    this.state = {
      role: localStorage.getItem('role') || 'NONE',
      currentQuestion: questions[study - 1],
      study: study,
      firstText: '',
      secondText: '',
      thirdText: '',
      finishedFirst: false,
      finishedSecond: false,
      finishedThird: false
    };

    this.clickedSubmit = this.clickedSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  clickedSubmit(number) {
    if (number === 1 && this.state.firstText.length) {
      this.setState({
        finishedFirst: true
      });
    } else if (number === 2 && this.state.secondText.length) {
      this.setState({
        finishedSecond: true
      });
    } else if (number === 3 && this.state.thirdText.length) {
      this.setState({
        finishedThird: true
      });
    }
  }

  handleChange(e, number) {
    if (number === 1) {
      this.setState({
        firstText: e.target.value
      });
    } else if (number === 2) {
      this.setState({
        secondText: e.target.value
      });
    } else if (number === 3) {
      this.setState({
        thirdText: e.target.value
      });
    }
  }

  render() {
    const { role } = this.props;
    const { currentQuestion } = this.state;

    const getQuestions = () => {
      return (
        <Row>
          <Col xs={10} xsOffset={1}>
            <p>
              {' '}
              <UnClickableScreenReader text={currentQuestion['before1']} />
              {currentQuestion['before1']}
            </p>
            <div className="questionDiv">
              <FormGroup controlId="firstText">
                <ControlLabel>
                  {currentQuestion['question1']}
                </ControlLabel>
                <FormControl
                  componentClass="textarea"
                  type="text"
                  value={this.state.firstText}
                  onChange={e => this.handleChange(e, 1)}
                />
              </FormGroup>
              <Col xs={12} className="text-center" style={{ margin: '10px 0' }}>
                <Button
                  className="btn btn-blue"
                  onClick={() => this.clickedSubmit(1)}
                >
                  Submit
                </Button>
              </Col>
            </div>
            {this.state.finishedFirst && (
              <div style={{ marginTop: 100 }}>
                <UnClickableScreenReader text={currentQuestion['identifyText']} />
                {currentQuestion['identifyNode']}
                <UnClickableScreenReader text={currentQuestion['afterText']} />
                {currentQuestion['afterNode'] ? currentQuestion['afterNode'] : currentQuestion['afterText']}
                <div className="questionDiv">
                  <FormGroup controlId="secondText">
                    <ControlLabel>
                      {currentQuestion['question2']}
                    </ControlLabel>
                    <FormControl
                      componentClass="textarea"
                      type="text"
                      value={this.state.secondText}
                      onChange={e => this.handleChange(e, 2)}
                    />
                  </FormGroup>
                  <Col
                    xs={12}
                    className="text-center"
                    style={{ margin: '10px 0 20px 0px' }}
                  >
                    <Button
                      className="btn btn-blue"
                      onClick={() => this.clickedSubmit(2)}
                    >
                      Submit
                    </Button>
                  </Col>
                </div>
              </div>
            )}
            {this.state.finishedSecond && (
              <div style={{ marginTop: 100 }}>
                <UnClickableScreenReader text={currentQuestion['assistText']} />
                {currentQuestion['assistNode']}
                <div className="questionDiv">
                  <FormGroup controlId="secondText">
                    <ControlLabel>
                      {currentQuestion['question3']}
                    </ControlLabel>
                    <FormControl
                      componentClass="textarea"
                      type="text"
                      value={this.state.thirdText}
                      onChange={e => this.handleChange(e, 3)}
                    />
                  </FormGroup>
                  <Col
                    xs={12}
                    className="text-center"
                    style={{ margin: '10px 0' }}
                  >
                    <Button
                      className="btn btn-blue"
                      onClick={() => this.clickedSubmit(3)}
                    >
                      Submit
                  </Button>
                  </Col>
                </div>
              </div>
            )}
          </Col>
        </Row>
      );
    };

    const getSolution = () => {
      if (this.state.finishedThird) {
        return (
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text={currentQuestion['referText']} />
              {currentQuestion['referNode']}
              <UnClickableScreenReader
                text={`Every situation is going to be different and we’re all likely to notice and respond slightly differently 
                when incorporating elements of Identify, Assist, Refer. The key is to trust your intuition and be authentic 
                when you check in.`}
              />
              <p>
                Every situation is going to be different and we’re all likely to notice and respond slightly differently
                when incorporating elements of Identify, Assist, Refer. The key is to trust your intuition and be authentic
                when you check in.
              </p>
            </Col>
            <section>
              <div className="container">
                <Row className="text-center">
                  <Col xs={12}>
                    <LinkContainer
                      to={`${url.CASESTUDIES}?completed=true`}
                      style={{ width: '300px' }}
                      className="btn btn-blue case-study-bot-nav"
                    >
                      <Button>Click here to try another scenario</Button>
                    </LinkContainer>
                    <span className="xs-hide">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <LinkContainer
                      to={url.TRAINING_COMPLETED}
                      style={{ width: '300px' }}
                      className="btn btn-blue case-study-bot-nav"
                    >
                      <Button>Click here to finish the training</Button>
                    </LinkContainer>
                  </Col>
                </Row>
              </div>
            </section>
          </Row>
        );
      }
      return null;
    };

    return (
      <div className="education-module">
        <Navigation role={role} />
        <TextHero childTitle={'Case Studies'} />

        <section
          className="no-padd"
          style={{ marginTop: '-100px', zIndex: '1' }}
        >
          <div id="maincontent" className="container intro">
            <Row className="text-center">
              <Col xs={12}>
                <p className="heading-text">
                  Scenario {this.state.study}: {currentQuestion['name']}
                  <h1
                    style={{ marginTop: 0, marginBottom: 0 }}
                    className="txt-blue"
                  >
                    {currentQuestion['occupation']}
                  </h1>
                  {currentQuestion['ideal']}
                </p>
              </Col>
            </Row>
          </div>
        </section>
        <section>
          <div className="container">{getQuestions()}</div>
        </section>
        <section>
          <div className="container">{getSolution()}</div>
        </section>
        <Footer />
      </div>
    );
  }
}

CaseStudiesQuestions.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

CaseStudiesQuestions.defaultProps = {
  role: {}
};

export default reduxConnect.role(CaseStudiesQuestions);



// WEBPACK FOOTER //
// ./src/containers/CaseStudies/CaseStudiesQuestions/index.jsx